import { Button, Input, Flex } from '@chakra-ui/react';
import { ChangeEvent, RefObject, useRef } from 'react';
import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CustomFormControl } from './CustomFormControl';

export interface ICustomFileInput {
  label?: string;
  error?: FieldError | undefined;
  value?: any;
  helperText?: string;
  onChange?: (e: File | undefined) => void;
}

export const CustomFileInput = (props: ICustomFileInput) => {
  const { t } = useTranslation();
  const { label, helperText, value, onChange, ...restProps } = props;
  const inputRef: RefObject<HTMLInputElement> = useRef(null);
  const fileName = (value && value.name) || '';

  return (
    <CustomFormControl
      label={label}
      error={restProps?.error}
      value={fileName}
      helperText={helperText}
      rightEl={{ sx: { bottom: 0, top: 'initial' } }}
    >
      <Flex flexWrap={{ base: 'wrap', lg: 'nowrap' }} w='100%'>
        <Button
          variant='primary'
          minW={{ base: '100%', lg: '150px' }}
          minH='48px'
          mr={10}
          mb={{ base: 2, lg: 0 }}
          onClick={() => inputRef?.current && inputRef.current.click()}
        >
          {t('upload')}
        </Button>
        <input
          type='file'
          style={{ display: 'none' }}
          ref={inputRef}
          {...restProps}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (onChange) {
              onChange(e?.target?.files?.[0]);
            }
          }}
        />
        <Input
          onClick={() => inputRef?.current && inputRef.current.click()}
          value={fileName}
          onChange={() => {}}
          readOnly={true}
        />
      </Flex>
    </CustomFormControl>
  );
};
